import Vue from "vue";

import numberFormatFilter from "./numberFormat.filter";
import dateTimeFilter from "./dateTime.filter";
import denomConverter from "./denomConverter.filter";
import denomFormat from "./denomFormat.filter";
import currencyFormat from "./currency.filter";
import lamportsConverter from "./lamportsConverter.filter";
import "./text.filter";
import "./numberUtils.filter";

Vue.filter("numberFormat", numberFormatFilter);
Vue.filter("datetime", dateTimeFilter);
Vue.filter("denomConverter", denomConverter);
Vue.filter("denomFormat", denomFormat);
Vue.filter("currency", currencyFormat);
Vue.filter("lamportToSol", lamportsConverter);
